<template>
  <div class="kalkulator-row form-group row" v-bind:class="{ hasError: error }" v-bind:data-block-title="title">
    <label class="col-lg-1 col-form-label" data-title="Producent">{{company}}</label>
    <label class="col-lg-3 input-col" data-title="Numer części">
      <span class="copy">
        <input :value="partsKey" type="text" class="form-control" readonly>
        <button
        v-clipboard="copyData"
        @success="handleSuccess"
        >
          <img src="/static/copy-icon.svg">
        </button>
        <span v-if="showCopyInfo" class="mftooltip">Numer częsci został skopiowany!</span>
      </span>
    </label>
    <label class="col-lg-5 col-form-label" data-title="Opis">{{title}}</label>
    <div class="col input-col" data-title="Twoja cena zakupu">
      <input type="text" class="form-control" v-bind:class="{ 'is-invalid': error }" v-model="value" v-on:keyup="keyup" placeholder="Wpisz cenę netto">
      <div class="mftooltip">
        Wpisz ostateczną kwotę netto, czyli taką za ile możesz kupić daną część (czyli z uwzględnieniem ewentualnego rabatu)
      </div>
      <div class="invalid-feedback">
        {{msg}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'KalkulatorInput',
  props: {
    title: {
      type: String
    },
    company: {
      type: String
    },
    between: {
      type: Array
    },
    partsKey: {
      type: String
    },
    index: {
      type: Number
    },
    id: {
      type: Number
    }
  },
  data: function () {
    return {
      msg: '',
      error: false,
      value: null,
      copyData: 'null',
      showCopyInfo: false
    }
  },
  created: function () {
    this.value = null
    this.copyData = this.partsKey
  },
  methods: {
    keyup: function () {
      let status = this.validate()
      switch (status) {
        case 2:
          this.$emit('change', this.id, null, this.index)
          break
        case 3:
          this.$emit('change', this.id, null, this.index)
          break
        default:
          this.value = Math.round(parseFloat(this.value) * 100) / 100
          this.$emit('change', this.id, this.value, this.index)
          break
      }
      let timeOutId = 0
      clearTimeout(timeOutId)
      timeOutId = setTimeout(this.displayError.bind(this), 1500)
    },
    validate: function () {
      let value = parseFloat(this.value)
      if (value < this.between[0] || value > this.between[1]) {
        return 2
      }
      // Correct send to parent
      if (value) {
        return 1
      }
      // This is not number
      return 3
    },
    displayError: function () {
      let status = this.validate()
      switch (status) {
        case 2:
          this.msg = 'Upewnij się czy wpisałeś dobrą cenę!'
          this.error = true
          break
        case 3:
          this.msg = 'To nie jest liczba!'
          this.error = true
          break
        default:
          this.error = false
          this.msg = ''
          break
      }
    },
    handleSuccess: function () {
      this.showCopyInfo = true
      setTimeout(this.hideCopyInfo.bind(this), 1500)
    },
    hideCopyInfo: function () {
      this.showCopyInfo = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/variables';
@import './../assets/mixin';

.input-col {
  position: relative;
  .mftooltip {
    position: absolute;
    top: -100px;
    left: 50%;
    font-size: 12px;
    transform: translateX(-50%);
    line-height: 16px;
    background-color: white;
    padding: 5px;
    border-radius: 3px;
    border: 1px solid darken(#F2F2F2, 10);
    width: 160px;
  }
}
.mftooltip {
  display: none;
}

input {
  font-size: 13px;
}

input:focus~.mftooltip {
  display: block;
}

.col-form-label {
  font-size: 13px;
}
.copy{
  position: relative;
  display: block;
  width: 100%;
  .mftooltip{
    display: block;
    top:-50px;
  }
  input{
    padding-right: 25px;
  }
  button{
    background:#DE8315;
    width:18px;
    margin-top:-8px;
    height: 18px;
    border:0px;
    padding:0px;
    border-radius: 10px;
    right: 5px;
    top:50%;
    cursor: pointer;
    position: absolute;
    img{
      position: absolute;
      top:50%;
      margin-top: -5px;
      left:50%;
      margin-left: -5px;
      width: 10px;
      height: 10px;
    }
  }
}
@include underTablet(){
  [data-title]{
    box-sizing: border-box;
    display: block;
    position: relative;
    padding-left: 150px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 0px;
    border-bottom: 1px solid darken(#F2F2F2, 10);
    &::before{
      display: block;
      box-sizing: border-box;
      content: attr(data-title) ":";
      position: absolute;
      width: 140px;
      left:0px;
      padding: 0px 10px;
      font-size: 14px;
      top:50%;
      @include transform(translateY(-50%));
      margin-top:-2px;
      color:darken(#F2F2F2, 30);
      //background-color: darken(#F2F2F2, 10);
    }
  }
  [data-title="Opis"]{
    display: none;
  }
  [data-block-title]{
    margin-bottom:0px;
    &::before{
      display: block;
      box-sizing: border-box;
      content: attr(data-block-title);
      font-size: 14px;
      padding:10px;
      background: darken(#F2F2F2, 10);
      width: 100%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/KalkulatorInput.vue